<template>
  <div class="outdated">

    <div class="content__heading content__heading--center">
      <figure class="fusebox--emblem">
        <img src="@/assets/svg/fusebox_online_emblem.svg"/>
      </figure>
    </div>

    <section class="content--boxed">

      <div class="content--boxed__heading">
        <h1>
          <i class="icon--warning"></i> {{ $t('general.outdatedTitle') }}
        </h1>
      </div>

      <p>{{ $t('general.outdated')}}</p>

    </section>

  </div>
</template>

<script>
export default {
  name: 'Index'
}
</script>
